import React, { useEffect, useRef, useState } from 'react'
import Dictionary from '../index'
import { PageType } from '../constants'
import useDictMenu from '../hooks/useDictMenu'
import { Row, Col, Menu, Spin, App, Tooltip } from 'antd'
import styles from '../index.module.less'
import usePersistStoreStore from '@/store/persistStore'
import { getDictInfo, quoteProject } from '@/api/dictionary'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import useStore from '@/store/index'
import { QuoteType } from '@/views/exportRecord/constant'

const findTargetKey = (dicts: any[], domainId: string, dictName: string) => {
  let targetKey = ''
  dicts.forEach((item) => {
    const { children = [], id } = item
    if (id === parseInt(domainId)) {
      children.forEach((dict: any) => {
        const { dictname, key } = dict
        if (dictName === dictname) {
          targetKey = key
        }
      })
    }
  })
  return targetKey
}

const _window = window as any

// const mockData = {
//   ilinkRelItemId: 121,
//   directoryCode: 'SOC05',
//   directoryId: '56584',
//   dictName: 'AE不良事件',
//   directoryName: '内分泌疾病',
//   dictVersion: '0.0.3',
// }

const isMicro = !!_window.__MICRO_APP_ENVIRONMENT__
const microData = _window.microApp?.getData() || {
  quoteData: {},
}

const Quote = () => {
  const { setQuoteInfo } = useStore() as any
  const [searchParams, setSearchParams] = useSearchParams()
  const dictName = searchParams.get('dictName') as string
  const domainId = searchParams.get('domainId') as string
  const { t } = useTranslation()
  const { message } = App.useApp()
  const { setState } = usePersistStoreStore
  const [loading, setLoading] = useState(true)
  const { quoteDicts, onNavigate } = useDictMenu({
    includes: [PageType.Quote],
  })
  const [selectedKeys, setSelectedKeys] = useState<string[]>([])

  const init = async (_quoteData?: any) => {
    if (isMicro) {
      if (microData.token) {
        // 主应用token换取子应用token
        setState({ token: microData.token })
      }
    }
    let { quoteData = {} } = microData
    if (_quoteData) {
      quoteData = _quoteData
    }
    const capitalDictName = quoteData.dictName?.toUpperCase()
    const isWHODrug = capitalDictName.includes("WHODRUG");
    if (!quoteData?.dictName) {
      // WHODrug不需要版本号
      if (!isWHODrug && !quoteData?.dictVersion) {
        // 通知主应用页面加载完成
        _window.microApp?.forceDispatch({ type: 'load' })
        setLoading(false)
        return
      }
    }

    const quoteInfo: any = await getDictInfo({
      dictName: quoteData.dictName,
      version: quoteData.dictVersion,
      moduleType: 1
    })
    setQuoteInfo({
      ...quoteInfo,
      ...quoteData,
    })
    searchParams.set('domainId', quoteInfo.domainId)
    searchParams.set('domainName', quoteInfo.domainName)
    searchParams.set('dictName', quoteData?.dictName)
    if (capitalDictName.includes("MEDDRA")) {
      searchParams.set('isMedDRA', '1')
      searchParams.delete('isWHODrugC3')
    }
    if (isWHODrug) {
      searchParams.set('isWHODrugC3', '1')
      searchParams.delete('isMedDRA')
    }
    if (quoteData.searchName) {
      searchParams.set('searchName', quoteData.searchName)
    }
    setSearchParams(searchParams, { replace: true })
    // 通知主应用页面加载完成
    _window.microApp?.forceDispatch({ type: 'load' })
    setLoading(false)
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {

    function updateSearchName({ quoteData = {} }: { quoteData: any }) {
      init(quoteData)
    }
    _window.microApp?.addDataListener(updateSearchName, true)
    return () => {
      _window.microApp?.removeDataListener(updateSearchName)
    }
  }, [])

  useEffect(() => {
    if (quoteDicts.length > 0 && dictName && domainId) {
      const targetKey = findTargetKey(quoteDicts, domainId, dictName)
      setSelectedKeys([targetKey])
    }
  }, [quoteDicts])

  const handleQuote = async (data: any, quoteType: QuoteType, lltData: any) => {
    const { quoteData = {}, product } = microData
    try {
      if (product === 'ipvs') {
        _window.microApp?.forceDispatch({
          type: 'quoteOk',
          res: {
            data,
            lltData
          },
        })
        await quoteProject({
          ...data,
          projectCode: quoteData?.projectCode || null,
          ilinkRelItemId: quoteData?.ilinkRelItemId,
          isNeedPush: 1,
        })
        return
      }
      let res: any
      // 引用字典
      res = await quoteProject({
        ...data,
        projectCode: quoteData?.projectNo,
        ilinkRelItemId: quoteData?.ilinkRelItemId,
      })
      message.success(t('ikg.success', { action: t('dict.quote') }))
      if (isMicro) {
        _window.microApp?.forceDispatch({
          type: 'quoteOk',
          res,
        })
      }
    } catch (error) {
      if (isMicro) {
        _window.microApp?.forceDispatch({
          type: 'quoteFail',
        })
      }
    }
  }
  const dictionaryRef = useRef<any>()
  return (
    <Spin spinning={loading}>
      <Row wrap={false} gutter={24}>
        <Col flex={microData.product === 'ipvs' ? '215px' : "180px"}>
          <div className={styles.quoteMenu}>
            <Menu
              items={quoteDicts.map((i) => {
                return {...i, label: (
                  <Tooltip placement='topLeft' title={i.label}>
                      <span>{i.label}</span>
                  </Tooltip>
              )}
              })}
              onClick={(item: any) => {
                const { props } = item.item
                setSelectedKeys([props.dictname])
                if (props.menutype === 'dict') {
                  setQuoteInfo({})
                  onNavigate(props)
                  setTimeout(() => {
                    // 临时解决表格数据请求问题
                    dictionaryRef.current && dictionaryRef.current.reloadPage()
                  },1000)
                  return
                }
              }}
              selectedKeys={selectedKeys}
            />
          </div>
        </Col>
        <Col flex={1}>
          {!loading && (
            <Dictionary dictionaryRef={dictionaryRef} pageType={PageType.Quote} onQuote={handleQuote} />
          )}
        </Col>
      </Row>
    </Spin>
  )
}

export default Quote
